import { ResourceFilterElement, ResourceFiltersSelectedItem } from "../../../../../shared/components/createOrder/createOrderTypes"
import { StorageKey } from "../../../../../shared/cache/LocalCache"
import type { TranslationKey } from "../../../../localization/translations"
import { ResourceBooking } from "../../../../nonAdminUser/reports/upcomingOrders/resourceBookings/userResourceBookingTypes"

import { loadSavedFilters, saveFilters } from "./filterStorage"

const STORAGE_KEY = StorageKey.SERVICE_CENTER_RESOURCE_BOOKING_FILTERS
const MULTISELECT = "MultiSelect"
const RESOURCE_TYPE_MOBILE_AV = "MOBILE_AV"

const FILTER = {
    TABLE_ARRANGEMENTS: "tableSetupIds",
    MOBILE_AV: "mobileAv",
} as const

type L10n = { getString: (id: TranslationKey) => string }

function hasTableSetup(booking: ResourceBooking) {
    return (booking.bookingDetails?.resources ?? []).some((resource) => Boolean(resource.room?.tableSetup))
}

function hasResourceType(booking: ResourceBooking, resourceType: string) {
    return (booking.bookingDetails?.resources ?? []).some((resource) => resource.resourceType === resourceType)
}

export function buildResourceBookingFilterElements(l10n: L10n): ResourceFilterElement[] {
    return [
        {
            identifier: FILTER.TABLE_ARRANGEMENTS,
            elementType: MULTISELECT,
            name: FILTER.TABLE_ARRANGEMENTS,
            translationKey: "resources-create-edit-room-general-tab-table-arrangements",
            values: [{ key: l10n.getString("resources-create-edit-room-general-tab-table-arrangements"), value: FILTER.TABLE_ARRANGEMENTS }],
        },
        {
            identifier: FILTER.MOBILE_AV,
            elementType: MULTISELECT,
            name: FILTER.MOBILE_AV,
            translationKey: "service-center-reports-dashboard-meeting-filter-mobile-av",
            values: [{ key: l10n.getString("service-center-reports-dashboard-meeting-filter-mobile-av"), value: FILTER.MOBILE_AV }],
        },
    ]
}

// Same shape as the project's filterResources: filters.every() with a switch on the filter identifier.
export function matchesResourceBookingFilters(
    booking: ResourceBooking,
    filters: ReadonlyArray<ResourceFiltersSelectedItem>,
) {
    return filters.every((filter) => {
        const values = filter.values.map((value) => value.value)
        if (!values.length) return true
        switch (filter.identifier) {
            case FILTER.TABLE_ARRANGEMENTS:
                return hasTableSetup(booking)
            case FILTER.MOBILE_AV:
                return hasResourceType(booking, RESOURCE_TYPE_MOBILE_AV)
            default:
                return true
        }
    })
}

export const loadSavedResourceBookingFilters = () => loadSavedFilters(STORAGE_KEY)
export const saveResourceBookingFilters = (filters: ResourceFiltersSelectedItem[]) => saveFilters(STORAGE_KEY, filters)
